import React, { createContext } from 'react';

export interface VocalInterfaceProps {
  currentText: string;
  setCurrentText: React.Dispatch<React.SetStateAction<string>>;
  isVocalInterface: boolean;
  setIsVocalInterface: React.Dispatch<React.SetStateAction<boolean>>;
  isChart: boolean;
  setIsChart: React.Dispatch<React.SetStateAction<boolean>>;
  isAdButtonClicked: boolean;
  setIsAdButtonClicked: React.Dispatch<React.SetStateAction<boolean>>;  
};

const contextDefault: VocalInterfaceProps = {
  currentText: '',
  setCurrentText: () => {},
  isVocalInterface: false,
  setIsVocalInterface: () => {},
  isChart: false,
  setIsChart: () => {},
  isAdButtonClicked: false,
  setIsAdButtonClicked: () => {}
};

const VocalInterfaceContext = createContext<VocalInterfaceProps>(contextDefault);

export default VocalInterfaceContext;